import React from 'react';

// Standardized status badge used across modules (Part B consistency pass).
const STYLES: Record<string, string> = {
  // positive / active
  active: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20',
  approved: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20',
  paid: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20',
  published: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20',
  completed: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20',
  // pending / processing
  pending: 'text-amber-400 bg-amber-400/10 border-amber-400/20',
  processing: 'text-amber-400 bg-amber-400/10 border-amber-400/20',
  review: 'text-amber-400 bg-amber-400/10 border-amber-400/20',
  needs_revision: 'text-amber-400 bg-amber-400/10 border-amber-400/20',
  // negative / inactive
  rejected: 'text-red-400 bg-red-400/10 border-red-400/20',
  failed: 'text-red-400 bg-red-400/10 border-red-400/20',
  cancelled: 'text-red-400 bg-red-400/10 border-red-400/20',
  expired: 'text-white/50 bg-white/5 border-white/10',
  inactive: 'text-white/50 bg-white/5 border-white/10',
  none: 'text-white/50 bg-white/5 border-white/10',
  refunded: 'text-purple-400 bg-purple-400/10 border-purple-400/20',
  vip: 'text-amber-400 bg-amber-400/10 border-amber-400/20',
};

const LABELS: Record<string, string> = {
  needs_revision: 'perlu revisi',
  none: 'belum',
};

export function StatusBadge({ status, className = '' }: { status: string; className?: string }) {
  const key = (status || '').toLowerCase();
  const cls = STYLES[key] || 'text-cyan-400 bg-cyan-400/10 border-cyan-400/20';
  const label = LABELS[key] || status;
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={`text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-full border ${cls} ${className}`}
    >
      {label}
    </span>
  );
}
